import api, { createApiService } from "../http"
import { IBill, IBillGetAll } from "../types/services-types/bill-types"
import { RequestGetAll } from "../types/services-types/http-types"

export default class BillService {

    static apiBillService = createApiService('/bill')

    static async GetBillsForUser(limit: number = 100, page: number = 0) {
        const response = await this.apiBillService.get<RequestGetAll<IBill[]>>(`/get-for-user`, {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async GetBills(limit: number = 100, page: number = 0)  {
        const response = await this.apiBillService.get<RequestGetAll<IBill[]>>(`/get-all`, {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async BillUser(formData: FormData) {
        const response = await this.apiBillService.post<IBill>(`/create-bill`, formData)
        return response.data
    }

    static async BillUserHTML(html: string) {
        const response = await this.apiBillService.post<IBill>(`/create-bill-html`, {html})
        return response.data
    }

    static async Remove(id: number | string) {
        const response = await this.apiBillService.get<number>(`/remove/${id}`)
        return response.data
    }
}